// import React, { useState } from "react";
// import styled from "styled-components";
// import { Link, useParams } from "react-router-dom";

// import { Swiper, SwiperSlide } from "swiper/react";
// import { Thumbs } from "swiper/modules";
// import "swiper/css";

// import productsArray from "../../DataJS/Products.js";
// import categoryData from "../../DataJS/categories.js";

// const NetRoop = () => {
//   const [thumbsSwiper, setThumbsSwiper] = useState(null);
//   const { id } = useParams();

//   const findProductDetails = productsArray.find(
//     (productItem) => productItem.id === parseInt(id),
//   );

//   const findCategory = categoryData.find(
//     (categoryItem) => categoryItem.id === findProductDetails.categoryId,
//   );

//   // Product not found
//   if (!findProductDetails) {
//     return (
//       <div className="container py-5 d-flex justify-content-center align-content-center">
//         <h3>Product Not Found</h3>
//         <Link to="/products">Back to Shop</Link>
//       </div>
//     );
//   }

//   const finalProductImages = [
//     findProductDetails.image,
//     ...Array.from({ length: 6 }, (_, index) => {
//       return findProductDetails[`detailsimage${index + 1}`];
//     }),
//   ].filter(Boolean);

//   // const productImages =
//   //   findProductDetails.images?.length > 0
//   //     ? findProductDetails.images
//   //     : [findProductDetails.image];

//   return (
//     <Wrapper>
//       <section
//         className="rs-breadcrumb-area rs-breadcrumb-one p-relative"
//         style={{
//           paddingTop: "45px",
//           paddingBottom: "45px",
//         }}
//       >
//         <div
//           className="rs-breadcrumb-bg"
//           style={{
//             backgroundImage: "url(/assets/images/bg/breadcrumb-bg-01.png)",
//           }}
//         ></div>
//         <div className="container">
//           <div className="row">
//             <div className="col-xxl-6 col-xl-8 col-lg-8">
//               <div className="rs-breadcrumb-content-wrapper">
//                 <div className="rs-breadcrumb-title-wrapper">
//                   <h1 className="rs-breadcrumb-title fs-1">Product Details</h1>
//                 </div>
//                 <div className="rs-breadcrumb-menu">
//                   <nav>
//                     <ul>
//                       <li>
//                         <span>
//                           <Link to="/">Home</Link>
//                         </span>
//                       </li>
//                       <li>
//                         <span>Product Details</span>
//                       </li>
//                     </ul>
//                   </nav>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       <section
//         className="rs-shop-area section-space "
//         style={{ paddingBottom: "50px" }}
//       >
//         <div className="container">
//           {/* <div className="row align-items-lg-center g-5"> */}
//           <div className="row align-items-start g-5">
//             <div className="col-md-6">
//               <div className="product-details-thumb-wrap">
//                 {/* main swiper slider */}
//                 <div className="product-details-thumb-top mb-10">
//                   <Swiper
//                     className="product-details-active p-relative"
//                     modules={[Thumbs]}
//                     spaceBetween={0}
//                     slidesPerView={1}
//                     thumbs={{
//                       swiper:
//                         thumbsSwiper && !thumbsSwiper.destroyed
//                           ? thumbsSwiper
//                           : null,
//                     }}
//                   >
//                     {finalProductImages.map((image, index) => (
//                       <SwiperSlide key={index}>
//                         <div className="product-details-thumb">
//                           <img
//                             src={image}
//                             alt={`${findProductDetails.name} ${index + 1}`}
//                             style={{
//                               width: "100%",
//                               border: "1px solid #EE5B09",
//                             }}
//                           />
//                         </div>
//                       </SwiperSlide>
//                     ))}
//                   </Swiper>
//                 </div>

//                 {/* ThumbsSwiper slider  */}
//                 <div className="product-details-thumb-bottom">
//                   <div className="product-details-slider-dot">
//                     <Swiper
//                       className="product-details-nav"
//                       modules={[Thumbs]}
//                       onSwiper={setThumbsSwiper}
//                       spaceBetween={5}
//                       slidesPerView={5}
//                       slidesPerGroup={1}
//                       watchSlidesProgress={true}
//                       centeredSlides={false}
//                       allowTouchMove={true}
//                       loop={false}
//                     >
//                       {finalProductImages.map((image, index) => (
//                         <SwiperSlide key={index}>
//                           <button className="custom-button" type="button">
//                             <img
//                               src={image}
//                               alt={`${findProductDetails.name} thumbnail ${
//                                 index + 1
//                               }`}
//                             />
//                           </button>
//                         </SwiperSlide>
//                       ))}
//                     </Swiper>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="col-md-6">
//               <div className="product-details-wrapper shop-details">
//                 <h3 className="product-details-title mb-10">
//                   {findProductDetails.title}
//                 </h3>

//                 <div className="product-details-categories product-details-more mb-5">
//                   <p>Categories:</p>
//                   <span>
//                     <Link to="#">
//                       {findCategory ? findCategory.category : "Uncategorized"}
//                     </Link>
//                   </span>
//                 </div>
//                 <div className="mb-15">
//                   {findProductDetails.description.map((item, index) => (
//                     <p key={index} className="mb-5">
//                       {item}
//                     </p>
//                   ))}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//     </Wrapper>
//   );
// };

// const Wrapper = styled.section`
//   .product-details-nav .swiper-slide {
//     margin-right: 4px;
//   }
//   .product-details-nav .swiper-wrapper {
//     gap: 4px;
//   }
// `;

// export default NetRoop;

import React, { useState } from "react";
import styled from "styled-components";
import { Link, useLocation } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Thumbs } from "swiper/modules";
import "swiper/css";

import productsArray from "../../DataJS/Products.js";
import categoryData from "../../DataJS/categories.js";
import { FaPlay } from "react-icons/fa";

const NetRoop = () => {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const location = useLocation();

  /* * ===== * URL -> Product * ===== */
  const pageData = {
    "/fishing-net": { title: "Fishing Net", subtitle: "Fishing Net" },
    "/agri_net": { title: "Agriculture Net", subtitle: "Agriculture Net" },
    "/garden_net": { title: "Garden Net", subtitle: "Garden Net" },
    "/build_net": {
      title: "Building Safety Net",
      subtitle: "Building Safety Net",
    },
    "/pp-rope": { title: "PP Danline Rope", subtitle: "PP Danline Rope" },
    "/hdpe-rope": {
      title: "HDPE Twine & Rope",
      subtitle: "HDPE Twine & Rope",
    },
  };

  const currentPage = pageData[location.pathname];

  /* =====  Find product by title  ===== */
  const findProductDetails = productsArray.find(
    (productItem) =>
      productItem.title?.toLowerCase() === currentPage.title.toLowerCase(),
  );

  /* =====  Find category ===== */
  const findCategory = findProductDetails
    ? categoryData.find(
        (categoryItem) => categoryItem.id === findProductDetails.categoryId,
      )
    : null;

  /* =====  Product not found ===== */
  if (!findProductDetails) {
    return (
      <div
        className="container  text-center"
        style={{ paddingTop: "90px", paddingBottom: "90px" }}
      >
        <h3>{currentPage.title}</h3>
        <p className="mt-3"> Product information is not available yet. </p>
        <Link to="/" className="rs-btn has-theme-orange has-icon has-bg">
          Back To Home
        </Link>
      </div>
    );
  }

  /* * ===== * Product Images * ===== * * Main image: * findProductDetails.image * * Detail images: * detailsimage1 * detailsimage2 * detailsimage3 * ... * * Empty images are automatically removed. */
  const finalProductImages = [
    findProductDetails.image,
    ...Array.from({ length: 6 }, (_, index) => {
      return findProductDetails[`detailsimage${index + 1}`];
    }),
  ].filter(Boolean);

  return (
    <Wrapper>
      {/* ========= Breadcrumb ========= */}
      <section
        className="rs-breadcrumb-area rs-breadcrumb-one p-relative"
        style={{ paddingTop: "45px", paddingBottom: "45px" }}
      >
        <div
          className="rs-breadcrumb-bg"
          style={{
            backgroundImage: "url(/assets/images/bg/breadcrumb-bg-01.png)",
          }}
        ></div>
        <div className="container">
          <div className="row">
            <div className="col-xxl-6 col-xl-8 col-lg-8">
              <div className="rs-breadcrumb-content-wrapper">
                <div className="rs-breadcrumb-title-wrapper">
                  <h1 className="rs-breadcrumb-title fs-1">
                    {currentPage.title}
                  </h1>
                </div>
                <div className="rs-breadcrumb-menu">
                  <nav>
                    <ul>
                      <li>
                        <span>
                          <Link to="/">Home</Link>
                        </span>
                      </li>
                      <li>
                        <span>{currentPage.title}</span>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ========= Product Details ========= */}
      <section
        className="rs-shop-area section-space"
        style={{ paddingBottom: "50px", paddingTop: "50px" }}
      >
        <div className="container">
          <span
            className="rs-section-subtitle has-theme-orange justify-content-center text-capitalize"
            style={{ marginBottom: "40px" }}
          >
            <FaPlay color="#EA5501" size={12} />
            Products information
          </span>

          <div className="row align-items-start g-5">
            {/* ===== Product Images ===== */}
            <div className="col-md-6">
              <div className="product-details-thumb-wrap">
                {/* Main Swiper */}
                <div className="product-details-thumb-top mb-10">
                  <Swiper
                    className="product-details-active p-relative"
                    modules={[Thumbs]}
                    spaceBetween={0}
                    slidesPerView={1}
                    thumbs={{
                      swiper:
                        thumbsSwiper && !thumbsSwiper.destroyed
                          ? thumbsSwiper
                          : null,
                    }}
                  >
                    {finalProductImages.map((image, index) => (
                      <SwiperSlide key={index}>
                        <div className="product-details-thumb">
                          <img
                            src={image}
                            alt={`${findProductDetails.title} ${index + 1}`}
                            style={{
                              width: "100%",
                              border: "1px solid #EE5B09",
                              display: "block",
                            }}
                          />
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>

                {/* Thumbnail Swiper */}
                {finalProductImages.length > 1 && (
                  <div className="product-details-thumb-bottom">
                    <div className="product-details-slider-dot">
                      <Swiper
                        className="product-details-nav"
                        modules={[Thumbs]}
                        onSwiper={setThumbsSwiper}
                        spaceBetween={5}
                        slidesPerView={5}
                        slidesPerGroup={1}
                        watchSlidesProgress={true}
                        centeredSlides={false}
                        allowTouchMove={true}
                        loop={false}
                      >
                        {finalProductImages.map((image, index) => (
                          <SwiperSlide key={index}>
                            <button className="custom-button" type="button">
                              <img
                                src={image}
                                alt={`${findProductDetails.title} thumbnail ${index + 1}`}
                              />
                            </button>
                          </SwiperSlide>
                        ))}
                      </Swiper>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* ===== Product Information ===== */}
            <div className="col-md-6">
              <div className="product-details-wrapper shop-details">
                <h3 className="product-details-title mb-10">
                  {findProductDetails.title}
                </h3>
                <div className="product-details-categories product-details-more mb-5">
                  <p>Categories:</p>
                  <span>
                    <Link to="#">
                      {findCategory
                        ? findCategory.category
                        : findProductDetails.subtitle}
                    </Link>
                  </span>
                </div>
                <div className="mb-15">
                  {findProductDetails.description?.map((item, index) => (
                    <p key={index} className="mb-5">
                      {item}
                    </p>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  .product-details-nav .swiper-slide {
    margin-right: 4px;
  }
  .product-details-nav .swiper-wrapper {
    gap: 4px;
  }
  .product-details-nav .custom-button {
    width: 100%;
    padding: 0;
    border: none;
    background: transparent;
    cursor: pointer;
  }
  .product-details-nav .custom-button img {
    width: 100%;
    height: 90px;
    object-fit: cover;
    display: block;
  }
`;
export default NetRoop;
